import { render, staticRenderFns } from "./input-dictionary.vue?vue&type=template&id=7fc5a5de"
import script from "./input-dictionary.vue?vue&type=script&lang=js"
export * from "./input-dictionary.vue?vue&type=script&lang=js"
import style0 from "./input-dictionary.vue?vue&type=style&index=0&id=7fc5a5de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports